import { OmniHeroesCommunity } from "@/types";
import React, { createRef } from "react";
import NewsModel from "@/api/news";
import { getUrlParmas } from "@/common/store";
import { FormattedMessage } from "react-intl";
import { getBrowser } from "@/common/utils";
import Loading from "@/component/loading";
import BackGame from "@/component/back-game";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const number_format = (
  num: number,
  decimals: number,
  dec_point?: string,
  thousands_sep?: string
) => {
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * dec_point：小数点符号
   * thousands_sep：千分位符号
   * */
  let number = (num + "").replace(/[^0-9+-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function (n: number, prec: number) {
      var k = Math.pow(10, prec);
      return "" + Math.ceil(n * k) / k;
    };
  let sy = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  var re = /(-?\d+)(\d{3})/;
  while (re.test(sy[0])) {
    sy[0] = sy[0].replace(re, "$1" + sep + "$2");
  }
  if ((sy[1] || "").length < prec) {
    sy[1] = sy[1] || "";
    sy[1] += new Array(prec - sy[1].length + 1).join("0");
  }
  return sy.join(dec);
};

class TopicHeader extends React.Component<{
  topicInfo?: OmniHeroesCommunity.TopicBean;
}> {
  render() {
    const { topicInfo } = this.props;
    return (
      <div className="topic-header">
        <p>{topicInfo?.title || ""}</p>
        <div className="tag-info">
          <div className="tag-list">
            {topicInfo?.tagList.map((tagItem) => {
              return (
                <div className="tag-item" key={tagItem}>
                  {tagItem}
                </div>
              );
            })}
          </div>
          <div>{topicInfo?.time || ""}</div>
        </div>
      </div>
    );
  }
}

type ClickOperate = {
  [key: string]: any;
};

class TopicBottom extends React.Component<{
  topicInfo?: OmniHeroesCommunity.TopicBean;
  clickOperate(f: ClickOperate): void;
}> {
  state = {
    clicked_like: 0,
    clicked_unlike: 0,
    clicked_share: 0,
  };
  render() {
    const { topicInfo } = this.props;
    return (
      <React.Fragment>
        <div className="topic-footer">
          <div className="autor-warp">
            <img src={topicInfo?.photo || ""}></img>
            <span>{topicInfo?.autor}</span>
          </div>
          <div className="topic-vital">
            <div className="active">
              <i className="iconfont icon-redu"></i>
              <p>{topicInfo?.rd}</p>
            </div>
            <div
              onClick={() => this.shareTopic()}
              className={`${
                (topicInfo?.time_share || this.state.clicked_share || 0) > 0
                  ? "active"
                  : ""
              }`}
            >
              <i className="iconfont icon-fenxiang"></i>
              <p>{number_format(topicInfo?.share || 0, 0)}</p>
            </div>
            <div
              onClick={() => this.operateTopic("like")}
              className={`${
                (topicInfo?.time_like || this.state.clicked_like || 0) > 0
                  ? "active"
                  : ""
              }`}
            >
              <i className={`iconfont icon-dianzan`}></i>
              <p>{number_format(topicInfo?.like || 0, 0)}</p>
            </div>
            <div
              onClick={() => this.operateTopic("unlike")}
              className={`${
                (topicInfo?.time_unlike || this.state.clicked_unlike || 0) > 0
                  ? "active"
                  : ""
              }`}
            >
              <i className="iconfont icon-chaping"></i>
              <p>{number_format(topicInfo?.unlike || 0, 0)}</p>
            </div>
          </div>
        </div>
        <BackGame />
      </React.Fragment>
    );
  }

  /**
   * 分享
   */
  shareTopic() {
    const l =
      process.env.NODE_ENV === "development" || process.env.BUILD_PATH == "uat"
        ? "http://49.51.69.43:9012"
        : "https://community.omnidreamgames.com";
    window.alert(
      JSON.stringify({
        action: "share",
        shareMsg: this.props.topicInfo?.title,
        imageUrl: this.props.topicInfo?.thumbnail,
        linkUrl: `${l}/detail.html?id=${this.props.topicInfo?.id}`,
      })
    );
    this.operateTopic("share");
  }

  operateTopic(type: "like" | "unlike" | "share") {
    switch (type) {
      case "share":
        // 如果已分享
        if (this.props.topicInfo?.time_share || this.state.clicked_share > 0) {
          return true;
        }
        const sl = !(
          this.props.topicInfo?.time_share || this.state.clicked_share > 0
        );
        this.setState({
          clicked_share: +sl,
        });
        const sot = this.props.topicInfo?.time_share;
        const shareCount = this.props.topicInfo?.share;
        this.props.clickOperate({
          time_share: !sl && this.props.topicInfo?.time_share ? 0 : 1,
          share:
            !sl && this.props.topicInfo?.time_share
              ? (this.props.topicInfo?.share || 0) - 1
              : (this.props.topicInfo?.share || 0) + 1,
        });
        NewsModel.share(getUrlParmas("id")).catch(() => {
          this.setState({
            clicked_share: +!sl,
          });
          this.props.clickOperate({
            time_share: sot,
            share: shareCount,
          });
        });
        break;
      case "like":
        // 如果已踩
        if (
          this.props.topicInfo?.time_unlike ||
          this.state.clicked_unlike > 0
        ) {
          return true;
        }
        const l = !(
          this.props.topicInfo?.time_like || this.state.clicked_like > 0
        );
        this.setState({
          clicked_like: +l,
        });
        const ot = this.props.topicInfo?.time_like;
        const likeCount = this.props.topicInfo?.like;
        this.props.clickOperate({
          time_like: !l && this.props.topicInfo?.time_like ? 0 : 1,
          like:
            !l && this.props.topicInfo?.time_like
              ? (this.props.topicInfo?.like || 0) - 1
              : (this.props.topicInfo?.like || 0) + 1,
        });
        const fn = l ? NewsModel.like : NewsModel.cancelLike;
        fn(getUrlParmas("id")).catch(() => {
          this.setState({
            clicked_like: +!l,
          });
          this.props.clickOperate({
            time_like: ot,
            like: likeCount,
          });
        });
        break;
      case "unlike":
        // 如果已赞
        if (this.props.topicInfo?.time_like || this.state.clicked_like > 0) {
          return true;
        }
        const ul = !(
          this.props.topicInfo?.time_unlike || this.state.clicked_unlike > 0
        );
        this.setState({
          clicked_unlike: +ul,
        });
        const uot = this.props.topicInfo?.time_unlike;
        const ulike = this.props.topicInfo?.unlike;
        this.props.clickOperate({
          time_unlike: !ul && this.props.topicInfo?.time_unlike ? 0 : 1,
          unlike:
            !ul && this.props.topicInfo?.time_unlike
              ? (this.props.topicInfo?.unlike || 0) - 1
              : (this.props.topicInfo?.unlike || 0) + 1,
        });
        const ufn = ul ? NewsModel.unlike : NewsModel.cancelUnlike;
        ufn(getUrlParmas("id")).catch(() => {
          this.setState({
            clicked_unlike: +!ul,
          });
          this.props.clickOperate({
            time_unlike: uot,
            unlike: ulike,
          });
        });
        break;
    }
  }
}

/**
 * 游客底部
 */
class VisitorTopicBottom extends React.Component {
  download_url = {
    ios: "https://bit.ly/omniheroes",
    android: "https://play.google.com/store/apps/details?id=com.omnidream.ohs",
  };
  os = getBrowser();
  render() {
    return <BackGame />;
  }
}

export default class Topic extends React.Component {
  state: {
    topicInfo?: OmniHeroesCommunity.TopicBean;
    loading: boolean;
    url?: string;
    previewRef?: any;
  } = {
    topicInfo: undefined,
    loading: false,
    previewRef: createRef(),
  };
  render() {
    const uid = sessionStorage.getItem("uid");
    return (
      <Loading loading={this.state.loading} className="topic-warp">
        <TopicHeader topicInfo={this.state.topicInfo} />
        <PhotoProvider>
          <PhotoView src={this.state.url}>
            <div ref={this.state.previewRef} className="topic-preview">
              预览图片
            </div>
          </PhotoView>
        </PhotoProvider>
        <div
          className="topic-content"
          dangerouslySetInnerHTML={{
            __html: this.state.topicInfo?.html || "",
          }}
          onClick={(e) => {
            this.onContentClick(e);
          }}
        ></div>
        {uid ? (
          <TopicBottom
            topicInfo={this.state.topicInfo}
            clickOperate={(asMap: ClickOperate) => {
              let f: any = this.state.topicInfo || {};
              this.setState({
                topicInfo: {
                  ...f,
                  ...asMap,
                },
              });
            }}
          />
        ) : (
          <VisitorTopicBottom />
        )}
      </Loading>
    );
  }
  onContentClick(e: any) {
    if (e.target.nodeName === "A") {
      this.setState({ url: e.target.href });
      this.state.previewRef.current.click();
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        return false;
      }
    }
    return false;
  }
  componentDidMount() {
    const id = getUrlParmas("id");
    this.setState({
      loading: true,
    });
    NewsModel.getTopicInfo(id)
      .then((res) => {
        if (!res.deleted) {
          this.setState({
            topicInfo: res || {},
          });
        }
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }
  componentWillUnmount(): void {
    this.setState = () => false;
  }
}
